import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const invoiceApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getInvoices: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `invoices${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Invoice'),
        }),
        getInvoicesDashboard: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `invoices/dashboard${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Invoice'),
        }),
        getInvoice: build.query({
            query: (id) => {
                return {
                    url: `invoices/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Invoice', result),
        }),
        updateInvoice: build.mutation({
            query: ({id, data}) => {
                return {
                    url: `invoices/${id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: (result, error, {id}) => provideTag('Invoice', result, id),
        }),
        deleteInvoice: build.mutation({
            query: (id) => {
                return {
                    url: `invoices/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invoice'],
        }),
        createInvoice: build.mutation({
            query: (data) => {
                return {
                    url: `invoices`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invoice'],
        }),
        getInvoicePdf: build.query({
            query: (id) => ({
                url: `invoices/${id}/pdf`,
                method: 'GET',
            }),
            transformResponse: (res) => res,
        }),
        getInvoiceOverview: build.mutation({
            query: (data) => ({
                url: `invoices/overview`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (res) => res,
        }),
        createAutoInvoice: build.mutation({
            query: (data) => ({
                url: `invoices/auto`,
                method: 'POST',
                body: data,
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['Invoice'],
        }),
        resendInvoice: build.mutation({
            query: (id) => ({
                url: `invoices/${id}/resend`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: (result, error, id) => provideTag('Invoice', result, id),
        }),
        cancelInvoice: build.mutation({
            query: (id) => ({
                url: `invoices/${id}/cancel`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: (result, error, id) => provideTag('Invoice', result, id),
        }),
        sendUnpaidInvoicesToConsumer: build.mutation({
            query: (consumerId) => ({
                url: `invoices/send-unpaid-invoices/${consumerId}`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
        }),
        updateStatus: build.mutation({
            query: ({id, data}) => {
                return {
                    url: `invoices/updateStatus/${id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Invoice', 'MeterReading'],
        }),
    }),
    overrideExisting: false,
})

export default invoiceApi

export const {
    useGetInvoicesQuery,
    useGetInvoicesDashboardQuery,
    useGetInvoiceQuery,
    useDeleteInvoiceMutation,
    useCreateInvoiceMutation,
    useGetInvoicePdfQuery,
    useLazyGetInvoicePdfQuery,
    useGetInvoiceOverviewMutation,
    useUpdateInvoiceMutation,
    useCreateAutoInvoiceMutation,
    useUpdateStatusMutation,
    useResendInvoiceMutation,
    useCancelInvoiceMutation,
    useSendUnpaidInvoicesToConsumerMutation,
} = invoiceApi
